import { render, staticRenderFns } from "./PvcTree.vue?vue&type=template&id=60159061&"
import script from "./PvcTree.vue?vue&type=script&lang=js&"
export * from "./PvcTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports